// tslint:disable
export enum PayorType {
    /**
     * @description Insurance Provider
     */
    INS = 3,
    /**
     * @description Pharmacy Benefit Manager
     */
    PBM = 4,
    /**
     * @description Payer
     */
    PAYER = 32,
}
